import React, { Fragment } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { notificationValidations } from "./notificationConstant";
import FormInput from "../Common/FormInputs/MuiTextField";

const messageControlSx = {
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: 500,
};
const fieldRowSx = {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 500px)" },
    alignItems: "center",
    gap: 1.5,
    marginBottom: 2,
    "&:last-of-type": { marginBottom: 0 },
};
const sectionCardSx = {
    p: 2,
    mt: 1.5,
    boxShadow: 2,
    borderRadius: 1,
};

const EmailNotification = ({
    messageData = { subject: "", html: "", text: "" },
    handleMessageData,
}) => {
    return (
        <Fragment>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
              Message
            </Typography>
            <Paper sx={sectionCardSx}>
                <Box sx={fieldRowSx}>
                    <Typography variant="body2" fontWeight={600}>Subject:</Typography>
                    <Box sx={messageControlSx}>
                        <FormInput
                            type="textarea"
                            rows={2}
                            placeholder="Write a Message"
                            value={messageData?.subject}
                            onChange={(e) => {
                                handleMessageData("subject", e?.target?.value?.substring(0, notificationValidations?.email?.subject?.maxLength))
                            }}
                            sx={{ maxWidth: 500 }}
                        />
                        <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                          {(messageData?.subject?.length > notificationValidations?.email?.subject?.maxLength
                            ? notificationValidations?.email?.subject?.maxLength
                            : messageData?.subject?.length) + "/" + notificationValidations?.email?.subject?.maxLength}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={fieldRowSx}>
                    <Typography variant="body2" fontWeight={600}>HTML:</Typography>
                    <Box sx={messageControlSx}>
                        <FormInput
                            type="textarea"
                            rows={6}
                            placeholder="Write a Message"
                            value={messageData?.html}
                            onChange={(e) => {
                                handleMessageData('html', e.target.value?.substring(0, notificationValidations?.email?.html?.maxLength))
                            }}
                            sx={{ maxWidth: 500 }}
                        />
                        <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                          {(messageData?.html?.length > notificationValidations?.email?.html?.maxLength
                            ? notificationValidations?.email?.html?.maxLength
                            : messageData?.html?.length) + "/" + notificationValidations?.email?.html?.maxLength}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={fieldRowSx}>
                    <Typography variant="body2" fontWeight={600}>Text:</Typography>
                    <Box sx={messageControlSx}>
                        <FormInput
                            type="textarea"
                            rows={4}
                            placeholder="Write a Message"
                            value={messageData?.text}
                            onChange={(e) => {
                                handleMessageData('text', e.target.value?.substring(0, notificationValidations?.email?.text?.maxLength))
                            }}
                            sx={{ maxWidth: 500 }}
                        />
                        <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                          {(messageData?.text?.length > notificationValidations?.email?.text?.maxLength
                            ? notificationValidations?.email?.text?.maxLength
                            : messageData?.text?.length) + "/" + notificationValidations?.email?.text?.maxLength}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Fragment>
    );
}


export default EmailNotification